import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, CheckBox, Input, Icon, Card, Modal, Tooltip } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View, TouchableOpacity, Linking } from 'react-native';
import {CustomerInfo} from './topBar.js'
import {useSelector, useDispatch} from 'react-redux';
import moment from 'jalali-moment'
import * as ImagePicker from 'expo-image-picker';
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../root.navigation.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
const PlusIcon = (props) => (
  <Icon {...props}  name='plus'/>
);


const LinkIcon = (props) => (
  <Icon {...props}  name='external-link-outline'/>
);
const DownloadIcon = (props) => (
  <Icon {...props}  name='download-outline'/>
);

const  width= Dimensions.get('window').width-40
export const FinishedTask = ({ navigation }) => {
  const data = useSelector( state => state.request.data);

  const [modal2, setModal2] = useState(false)
  const [receiverChecked, setReceiverChecked] = useState(false);
  const [customerChecked, setCustomerChecked] = useState(true);

  const [payment, setPayment] = useState(0)
  const [modal, setModal] = useState(false)
  const [checked, setChecked] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [checked10, setChecked10] = useState(false);
  const [desc, setDesc] = useState('')
  const [cost1, setCost1] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [warranty, setWarranty] = useState(false)
  const [costs, setCosts] = useState([])
  const [newUri, setNewUri] = useState(null);
  const [oldUri, setOldUri] = useState(null);
  const [signUri, setSignUri] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0)
  const [dueDate, setDueDate] = useState('')
  const [invoice, setInvoice] = useState()
  const [visible, setVisible] = React.useState(false);

  const getData = async(start)=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/invoice/invoice_details',
      {
        request: data.id,
      } ,
      {
        headers: {Authorization: `Bearer ${token}`}
      });

      const response2 = await trackerApi.post('/invoice/status',
        {
          request_id: data.id,
        } ,
        {
          headers: {Authorization: `Bearer ${token}`}
        });
      console.log({response2: response2.data});
      if(response.data.status) {
        setCosts(response.data.cost)
        console.log(start);
        response.data.cost.map((data)=>{
          start += (Number(data.service_cost) * Number(data.qty))
          console.log(start);
        })
        setTotalPrice(start)
      }
      else showMessage({
          message: `خطای دیتابیس 1`,
          type: "danger",
        });

        if(response2.data.status) {
          setDesc(response2.data.results.description)
          setInvoice(response2.data.results)
          setName(response2.data.results.receptor_name)
          setPhone(response2.data.results.receptor_phone)
          setWarranty(response2.data.results.warranty===1)
          setSignUri(`data:image/png;base64,${String.fromCharCode.apply(null, response2.data.results.receptor_signature)}`)
          setNewUri(`https://api.fntpf.ir/assets/uploaded/boards/${response2.data.results.newimage_uri}`)
          setOldUri(`https://api.fntpf.ir/assets/uploaded/boards/${response2.data.results.oldimage_uri}`)
          setDueDate(response2.data.results.due_date)
          // response.data.cost.map((data)=>{
          //   start += Number(data.service_cost)
          // })
          // setTotalPrice(start)
        }
        else showMessage({
            message: `خطای دیتابیس 2`,
            type: "danger",
          });

    }
  useEffect(() => {
      getData(0)
  }, []);

console.log({signUri});
const sendFactor = async() =>{
  const token =  await AsyncStorage.getItem('userId');
  const response = await trackerApi.post('/invoice/resendInvoice', {request_id: data.id, customerPhone: data.merchant_phone}, {
    headers: {Authorization: `Bearer ${token}`}
  })
  if(response.data.status){
    showMessage({
          message: `با موفقیت ارسال شد`,
          type: "success",
        });
        RootNavigation.navigate('Menu')
  } else showMessage({
        message: `خطا در ارسال فاکتور`,
        type: "danger",
      });

}
  return (
      <Layout level='3' style={styles.container}>
        <SafeAreaView>
        <ScrollView>

            <View style={{justifyContent:'space-between', alignItems:'center'}}>
              <CustomerInfo />
            </View>

            {invoice&&invoice.status=='cancel' ?
            <>
            <View style={{flexDirection:'row', justifyContent:'space-between', marginTop:15}}>
              <Layout level='2' style={{alignItems:'center',marginHorizontal:10,flex:2, borderRadius:10,  borderColor:'#134A93', borderWidth:1}}>
                <Text category='h5' status='primary'> {dueDate.split('T')[0]}</Text>
              </Layout>
            </View>
            <Layout style={{marginTop:10, padding:10,marginHorizontal:20,borderRadius:10, borderColor:'#134A93', borderWidth:1}}>
            <Text category='h6' status='primary'>{invoice.cancel_reason}</Text>
            <Text status='primary'>توضیحات تکنسین:</Text>
            <Text>{invoice.description}</Text>
            </Layout>
            </>
            :<View>
            <View style={{flexDirection:'row', justifyContent:'space-between', marginTop:15}}>
              <Layout level='2' style={{alignItems:'center',marginHorizontal:10,flex:2, borderRadius:10,  borderColor:'#134A93', borderWidth:1}}>
                <Text category='h5' status='primary'> {dueDate.split('T')[0]}</Text>
              </Layout>
              <Layout level='2' style={{flexDirection:'row', alignItems:'center',paddingHorizontal:5,marginHorizontal:10,flex:3, borderRadius:10,  borderColor:'#134A93', borderWidth:1}}>
                <Text category='c1'>قابل پرداخت: </Text>
                <Text category='h5' status='primary'>{warranty? 0 :totalPrice.toLocaleString()}</Text>
                <Text category='c1' status='primary'> ریال</Text>

              </Layout>
            </View>
            <CheckBox
              style={{ marginHorizontal:15, marginTop:10}}
              checked={warranty}
              disabled
              onChange={nextChecked => setWarranty(nextChecked)}>
              <Text>
                 خدمات شامل گارانتی می‌باشد.
              </Text>

            </CheckBox>
            {invoice&&<CheckBox
              style={{ marginHorizontal:15, marginTop:10}}
              checked={invoice.sherkati ? true : false}
              disabled>

              <Text>
                  کار غیر شرکتی
              </Text>

            </CheckBox>}
            {invoice&&invoice.sherkati == '1' &&<Text appearance='hint' style={{ marginHorizontal:15, marginTop:1}}>توضیحات کار غیرشرکتی: {invoice.sherkati_desc}</Text>}
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>موارد انجام شده</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'flex-start', borderColor:'#134A93', borderWidth:1}}>
              {

                  costs.length>0 ? costs.map((data, index)=>{
                    const renderToggleButton = (): React.ReactElement => (
                      <TouchableOpacity key={index} onPress={() => setVisible(index+1)} style={{width: width-40, flexDirection:'row', justifyContent:'space-between'}}>
                      <CheckBox
                        style={{ marginHorizontal:15, marginBottom:10}}
                        checked={true}
                         onChange={() => setVisible(index+1)}
                        >
                        <Text category='c2' >
                           {data.service_name}
                        </Text>
                        </CheckBox>

                      {/*  <Text category='c2' style={{width: width*0.2}}>
                        { (Number(data.service_cost) * Number(data.qty)).toLocaleString()} ریال
                        </Text>*/}
                        {/*  <Text  style={{width: width*0.1}}>
                             {`${data.qty} x   `}
                          </Text>*/}

                      </TouchableOpacity>
                    );
                    return(
                        <Tooltip
                        anchor={renderToggleButton}
                        visible={(visible-index == 1 ? true : false)}
                        placement='top'
                        onBackdropPress={() => setVisible(0)}
                      >
                      {`${data.service_name} \n`}

                          قیمت واحد: { data.service_cost.toLocaleString()} ریال
                          {`    تعداد:  ${data.qty}\n`}
                          مجموع: { (Number(data.service_cost) * Number(data.qty)).toLocaleString()} ریال
                      </Tooltip>

                    )

                  }) : null
                }


            </Layout>

            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>توضیحات فاکتور</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>{desc}</Text>

            </Layout>
{ data.service_type ==='تعمیر' &&
<View>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>تصویر بورد قدیمی</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            {oldUri&&
            <Image
              style={{width:width*0.8, height: width*0.8/1.43, marginVertical:10}}
              source={{uri: oldUri}} />}
            </Layout>
</View>
}
{ data.service_type ==='تعمیر' &&
<View>
            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>تصویر بورد جدید</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            {newUri&&
            <Image
              style={{width:width*0.8, height: width*0.8/1.43, marginVertical:10}}
              source={{uri: newUri}} />}
            </Layout>
            </View>
            }

            <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>اطلاعات تحویل گیرنده</Text>
            <Layout style={{paddingVertical:10,marginHorizontal:20,borderRadius:10, alignItems:'center', borderColor:'#134A93', borderWidth:1}}>
            <Input
              placeholder ='نام تحویل گیرنده'
              value={name}
              disabled
              label='نام تحویل گیرنده'
              onChangeText = {newValue =>{ setName(newValue)}}
              style={{margin:10}}
              />
              <Input
                placeholder ='شماره تماس'
                value={phone}
                disabled
                label='شماره تماس تحویل گیرنده'
                onChangeText = {newValue =>{ setPhone(newValue)}}
                style={{margin:10}}
                keyboardType='numeric'
                maxLength={11}
                />
              {/*
              <Text style={{marginTop:10, marginHorizontal:15, marginBottom:5}} category='c1'>امضای مشتری</Text>
              <Layout level='2' style={{width: width*0.95, height: width*0.95*3/4, borderRadius:10}}>
              <Image
                style={{width:width*0.8, height: width*0.8/1.43, marginVertical:10}}
                source={signUri} />
              </Layout>
              */}

            </Layout>
            </View>
          }
          <View style={{flexDirection:'row', marginTop:10}}>
            <Button accessoryLeft={DownloadIcon} style={{flex:1, marginHorizontal:15, borderRadius:10}} status='warning' onPress={()=>{Linking.openURL(`https://panel.fntpf.ir/invoice/${(data.id * 1371 + 5119)*1375}`)}}>دانلود فاکتور</Button>
            <Button accessoryLeft={LinkIcon} status='success' style={{flex:1, marginHorizontal:15, borderRadius:10}} onPress={()=>{setModal2(true)}}>ارسال فاکتور</Button>
          </View>
          <View style={{flexDirection:'row', marginBottom:10}}>
            <Button style={{flex:1, margin:15, borderRadius:10}} onPress={()=>RootNavigation.navigate('CompletedTasks')}>بازگشت</Button>
          </View>
          </ScrollView>

          <Modal
             visible={modal2}
             backdropStyle={styles.backdrop}
             onBackdropPress={() => setModal2(false)}>
             <Card disabled={false}>

             <Text category='h6' status='primary' style={{marginBottom:10}}>ارسال فاکتور</Text>
             <View style={{justifyContent:'flex-end'}}>
             <CheckBox
               style={{ marginHorizontal:15, marginTop:10, marginBottom: 30}}
               checked={customerChecked}
               >
               <Text>
                ارسال فاکتور برای مشتری
               </Text>

             </CheckBox>

             </View>

               <Button style={{marginHorizontal:5}} onPress={()=>{sendFactor()}}>
                  ارسال
                </Button>
             </Card>
           </Modal>

        </SafeAreaView>
      </Layout>
  );
};

const styles = StyleSheet.create({
    container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
